import { memo } from 'react';
import Pressable from "../../../other/Pressable"
import { getEffectiveReferenceEmoji } from '../../../../utils/referenceLabel';

const BotoAjuntament = memo(({ ajuntament, ajuntamentLabel, ajuntamentEmoji, pissarraConfig, setAjuntamentModalClosed, disabled }) => {
    // Sense emoji triat, el botó mostra la brúixola (el concepte "punt de referència")
    const emoji = getEffectiveReferenceEmoji(ajuntamentLabel, ajuntamentEmoji, pissarraConfig?.ajuntamentEmoji) || '🧭';

    return ajuntament !== null && (
        <Pressable
            onClick={() => setAjuntamentModalClosed(false)}
            id="boto-ajuntament-container"
            style={{ transform: `rotate(${ajuntament*90}deg)`, backgroundColor: 'rgba(0, 255, 0, 0.2)' }}
            className={`boto boto-ajuntament ${disabled ? 'disabled' : ''}`}
            title="Punt de referència"
        >
            <div>{emoji}</div>
        </Pressable>
    );
}, (prevProps, nextProps) =>
    prevProps.disabled === nextProps.disabled &&
    prevProps.ajuntament === nextProps.ajuntament &&
    prevProps.ajuntamentLabel === nextProps.ajuntamentLabel &&
    prevProps.ajuntamentEmoji === nextProps.ajuntamentEmoji &&
    prevProps.pissarraConfig?.ajuntamentEmoji === nextProps.pissarraConfig?.ajuntamentEmoji
);

export default BotoAjuntament;
